module.exports = __webpack_public_path__ + "img/generate.f477fe32.svg";